import React, { Component } from 'react';
import xtend from 'xtend';

import _ from 'underscore';
import clone from 'clone';

const getInitialState = () => ({
    preferences: {},
    contexts: {},
    template: null
})

/**
 * @NOTE
 * @REFACTOR
 *
 * This is laregely unreadable and I feel bad about it
 *
 * The gist of this is to:
 * 1. Take a Source of Truth – "preference" – the state of the a given preference
 *  as returned from the initial GET request
 *
 * 2. Take Edits made from the UI – "edits"
 *
 * 3. Take a Preference change from the edits one at a time – "preferenceName" (because
 * if it exists in their then it has been changed by the user)
 *
 * 4. Know about the scope of change work [preferences|contexts]. This is because I
 *  wanted to keep the updating DRY so we use this function twice – once for each scope.
 *
 * @param {String} scope The scope of the udpate
 * @param {Object} edits The group of Edits made by the user
 * @param {Object} preference The Source of Truth
 * @param {String} preferenceName The name of the preference which has pending changes
 */
function update (scope, edits, preference, preferenceName) {

    for (let parent in preference) {

        // @XXX does this work from < 2.0 prefs to a 2.0 pref?
        let nameChanged = (
            parent == preferenceName &&
            edits.hasOwnProperty(preferenceName)
        )

        if (preference.hasOwnProperty(parent)) {
            if (typeof preference[parent] === "object") {
                for (let child in preference[parent].preferences) {
                    if (preference[parent].preferences.hasOwnProperty(child)) {
                        if (preferenceName == child) {
                            if (scope == 'preferences') {
                                preference[parent].preferences[child].value =
                                    edits[scope][preferenceName];
                            } else if (
                                scope == 'contexts' &&
                                preference[parent].preferences[child].hasOwnProperty('context') &&
                                !!edits[scope][preferenceName] === true
                            ) {
                                preference[parent].preferences[child].context =
                                    edits[scope][preferenceName]
                            }
                        }
                    }
                }
            } else if (nameChanged) {
                console.warn("TODO: Preference nameChanged");
                preference[parent] = edits[preferenceName];
            }
        }
    }
}


export default function PreferenceStateUtil (WrappedComponent) {
    return class extends Component {
        constructor (props) {
            super(props);

            this.state = _.clone(getInitialState());

            this.storeEdits = this.storeEdits.bind(this);
            this.assignTemplate = this.assignTemplate.bind(this);
            this.commitEdits = this.commitEdits.bind(this);
            this.undoEdits = this.undoEdits.bind(this);
            this.reducePreference = this.reducePreference.bind(this);
            this.getOriginalProperty = this.getOriginalProperty.bind(this);
        }

        // This seems to be the only way to reset the state.
        // I'm sorry
        undoEdits () {
            // this.state = _.clone(getInitialState());
            this.setState(getInitialState());
        }

        componentDidUpdate (prevProps, prevState) {
            window.stateUtil = this.state;
        }

        storeEdits (preferenceName, value, context) {
            // console.log('storeEdits', preferenceName, value, context);

            let currentState = _.clone(this.state);
            let edits = _.clone(currentState)

            if (preferenceName == 'showTwitterFeed' && !!context === true) {
                edits.contexts[preferenceName] = context;
            } else {
                edits.preferences[preferenceName] = value;
            }

            let updates = xtend(currentState, edits)
            this.setState(updates)
        }

        assignTemplate (index) {
            // Assumes v2.0 schema
            const template = this.props.preference.templates.options[index];
            const { settings } = template;

            Object.keys(settings).map(function (parent) {
                Object.keys(settings[parent]).map(function (child) {
                    this.storeEdits(child, settings[parent][child]);
                }, this);
            }, this);


            this.setState(function (state, props) {
                return xtend(state, {
                    template: template.value
                });
            });
        }

        commitEdits (errorCallback) {
            const self = this;
            const edits = this.state;

            // clone = Deep clone
            let final = clone(this.props.preference);

            // update the preferences
            Object.keys(edits.preferences).forEach(name => {
                if (name === 'name') {
                    // This is the Preference Title
                    final.name = edits.preferences[name]
                } else {
                    update('preferences', edits, final, name)
                }
            });

            // update the contexts
            Object.keys(edits.contexts).forEach(name => {
                update('contexts', edits, final, name)
            });

            if (!final.name) {
                errorCallback(['name'])
            } else {
                this.props.actions.handleSave(final, function (err, resp) {
                    if (err) {
                        console.warn(err, resp);
                        self.props.onWorkspaceAction({
                            type: 'snack', snack: {
                                type: 'error',
                                message: 'Failed to Save'
                            }
                        });
                    } else {
                        self.props.onWorkspaceAction({ type: 'snack', snack: {
                            type: 'success',
                            message: 'Settings Saved'
                        }});
                    }
                });
            }
        }

        getOriginalProperty (parent, property) {
            try {
                return this.props.preference[parent].preferences[property];
            } catch (e) {
                return false;
            }
        }

        /**
         * Reduces preference to a k/v pair
         *
         * @method
         * @param  {String} tab Active Tab
         * @param  {Object} pref Original Preference
         * @return {Object} preference
         */
        reducePreference (tab, pref) {
            const edits = this.state;
            var reduced = {};

            if (tab != 'templates') {
                const current = pref[tab].preferences;
                Object.keys(current).map(function (i) {
                    reduced[i] = current[i].value;
                });

                if (edits[tab] !== undefined) {
                    Object.keys(edits[tab].preferences).map(function (i) {
                        reduced[i] = edits[tab].preferences[i];
                    });
                }
            }

            return reduced;
        }

        render () {
            return React.createElement(
                WrappedComponent,
                xtend({
                    edits: this.state,
                    stateUtils: {
                        assignTemplate: this.assignTemplate,
                        commitEdits: this.commitEdits,
                        undoEdits: this.undoEdits,
                        storeEdits: this.storeEdits,
                        reducePreference: this.reducePreference,
                        getOriginalProperty: this.getOriginalProperty
                    }
                }, this.props),
                []
            );
        }
    };
}
